import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Popup, Progress, Button } from "semantic-ui-react";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";
import { Media } from "../../../styles/Media.js";

class ResourcePanelActions extends PureComponent {
  static propTypes = {
    limits: PropTypes.object.isRequired,
    availability: PropTypes.object.isRequired,
    used: PropTypes.number.isRequired,
    copyKey: PropTypes.string.isRequired,
    configOptions: PropTypes.object,
    doAdd: PropTypes.func.isRequired,
    doRemove: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    configOptions: {}
  };

  state = {
    remaining: 0,
    percent: 0,
    warning: false,
    error: false
  };

  // these values are all externally controlled and will always need updating
  static getDerivedStateFromProps(props) {
    const { limits, used } = props;

    const remaining = limits.available - used;
    const percent = (remaining / limits.maximum) * 100;
    const warning = percent <= 20;
    const error = remaining <= 0;

    return {
      remaining,
      percent,
      warning,
      error
    };
  }

  // -- HANDLERS -- //

  onAdd = () => {
    const { remaining } = this.state;

    if (remaining <= 0) return null;

    this.props.doAdd();
  };

  onRemove = () => {
    this.props.doRemove();
  };

  // -- RENDER -- //

  renderProgress = () => {
    const { remaining, percent, warning, error } = this.state;
    const {
      limits,
      availability: { permitted },
      configOptions: { singleMode, showLimits },
      copyKey,
      copy
    } = this.props;

    if (showLimits !== false && singleMode !== true && permitted) {
      return (
        <Progress
          className="limit-progress"
          percent={percent}
          warning={warning}
          error={error}
          size="small"
        >
          {`${remaining} ${copy(`${copyKey}.progress_separator`)} ${
            limits.maximum
          } ${copy(`${copyKey}.progress_description`)}`}
        </Progress>
      );
    }
  };

  renderActions = () => {
    const { remaining } = this.state;
    const {
      used,
      availability: { permitted },
      configOptions: { singleMode, showAdd, showRemove },
      copyKey,
      copy
    } = this.props;

    const showAddSingleMode = singleMode === true ? remaining > 0 : true;
    const showRemoveSingleMode = singleMode === true ? used > 0 : true;

    let addDisabled = !(remaining > 0);
    if (!permitted) addDisabled = false;

    if (showAdd !== false && showAddSingleMode) {
      return (
        <Button
          className="add-resource-cta"
          onClick={this.onAdd}
          icon="plus circle"
          content={copy(`${copyKey}.add_cta`)}
          type="button"
          disabled={addDisabled}
        />
      );
    }

    if (showRemove !== false && singleMode === true && showRemoveSingleMode) {
      return (
        <Button
          className="add-resource-cta"
          onClick={this.onRemove}
          icon="plus circle"
          content={copy(`${copyKey}.remove_cta`)}
          type="button"
          disabled={!(used > 0)}
        />
      );
    }
  };

  render = () => {
    const { copyKey, copy } = this.props;
    const { error } = this.state;

    const panelActions = (
      <Segment
        basic
        textAlign="right"
        style={{ paddingRight: "0px", paddingLeft: "0px" }}
      >
        <Media lessThan="smallTablet">
          {this.renderProgress()}
          {this.renderActions()}
        </Media>
        <Media greaterThanOrEqual="smallTablet">
          {this.renderActions()}
          {this.renderProgress()}
        </Media>
      </Segment>
    );

    if (error) {
      return (
        <Popup
          trigger={panelActions}
          content={copy(`${copyKey}.limit_reached`)}
          position="top right"
          size="mini"
          wide
          inverted
        />
      );
    }

    return panelActions;
  };
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourcePanelActions);
